import Debug   from './theme/debug.js';
import Helpers from './theme/helpers.js';

import AnimateScroll from './theme/components/animate-scroll.js';
import StickyHeader from './theme/components/sticky-header.js';
import MobileNavigation from './theme/components/mobile-navigation.js';
import MobileSearch from './theme/components/mobile-search.js';
import MobileFooterNavigation from './theme/components/mobile-footer-navigation.js';
import Tabs from './theme/components/tabs.js';
import Map from './theme/components/map.js';
import Lightbox from './theme/components/lightbox.js';
import CopyLink from './theme/components/copy-link.js';
import NavigationSelect from './theme/components/navigation-select.js';
import SearchForm from './theme/components/search-form.js';
import HeroCarousel from './theme/components/hero-carousel.js';
import EventCarousel from './theme/components/event-carousel.js';
import RegistrationForm from './theme/components/registration-form.js';
import PayAgain from './theme/components/pay-again.js';
import LoadMore from './theme/components/load-more.js';
import Share from './theme/components/share.js';
import Banner from './theme/components/banner.js';
import Newsletter from './theme/components/newsletter.js';
import Video from './theme/components/video.js';

window.theme = {
    globals: {
        isTouch: typeof window !== "undefined" && "ontouchstart" in window
    },
    init: function() {
        let theme = this;

        theme.debug = new Debug;
        theme.helpers = new Helpers;

        theme.animateScroll = new AnimateScroll;
        theme.stickyHeader = new StickyHeader;
        theme.mobileNavigation = new MobileNavigation;
        theme.mobileSearch = new MobileSearch;
        theme.mobileFooterNavigation = new MobileFooterNavigation;
        theme.tabs = new Tabs( document.body );
        theme.map = new Map;
        theme.lightbox = new Lightbox;
        theme.copyLink = new CopyLink;
        theme.navigationSelect = new NavigationSelect;
        theme.searchForm = new SearchForm;
        theme.heroCarousel = new HeroCarousel;
        theme.eventCarousel = new EventCarousel;
        theme.registrationForm = new RegistrationForm;
        theme.payAgain = new PayAgain;
        theme.share = new Share;
        theme.banner = new Banner;
        theme.video = new Video;
        
        document.querySelectorAll( '[data-load-more]' ).forEach( ( element ) => {
            new LoadMore( element );
        } );

        document.querySelectorAll( '[data-newsletter="form"]' ).forEach( ( element ) => {
            new Newsletter( element );
        } );
    }
}

document.addEventListener('DOMContentLoaded', () => {
    theme.init();
}, false);
